
































































































import Vue from "vue";
import Chart from "chart.js/auto";
import { UseModal } from "@/components/root/modal";
import MIPModalVue from "@/views/customize/mip/MIPModal.vue";
import DashboardCard from "../DashboardCard.vue";
import SkeletonLoaderItem from "@/components/SkeletonLoaderItem.vue";
import { state } from "../data/state";
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import SourcesModalVue from "@/components/modals/sources-modal/SourcesModal.vue";
import { CountItem } from "../data/model";
import { SharedState } from "@/common/state";

export default Vue.extend({
  props: ["source"],
  components: { DashboardCard, SkeletonLoaderItem },
  setup(props) {
    const { is_loading_all, data_per_application } = state;
    const hover_app_id = ref("");
    const open_mip_modal = async () => {
      SharedState.ifUserEnabledFeature(
        "auto_mip_labeling",
        async () => {
          await UseModal().show(MIPModalVue);
        },
        { premium_modal_key: "automatemicrosoftlabeling-popup-2024" }
      );
    };

    const total_count = computed(() => {
      const sum = data_per_application.value.reduce((acc, item) => {
        acc += item.count;
        return acc;
      }, 0);

      return sum == 0 ? 1 : sum;
    });

    const show_app_events_count_modal = async (app_id: string) => {
      await UseModal().show(SourcesModalVue, {
        source: app_id,
        sources: data_per_application.value.map((item) => item.id),
      });
    };

    const create_chart = (items: CountItem[]) => {
      const sum =
        data_per_application.value.reduce((acc, item) => {
          acc += item.count;
          return acc;
        }, 0) || 1;

      new Chart(document.getElementById("the-chart-2") as HTMLCanvasElement, {
        type: "doughnut",
        // @ts-ignore
        options: {
          onHover: function(event, chartElement) {
            if (chartElement.length > 0) {
              const { index } = chartElement[0];
              hover_app_id.value = data_per_application.value[index].id;
            }
          },
          plugins: {
            tooltip: {
              enabled: false,
            },
            legend: {
              display: false,
            },
          },
          onClick: (evt, item) => {
            if (item.length > 0) {
              const index = item[0].index;
              const counter_item = data_per_application.value[index];
              show_app_events_count_modal(counter_item.id);
              const datasetIndex = item[0].datasetIndex;
              console.log(
                `Clicked on index ${index} in dataset ${datasetIndex}`
              );
            }
          },
        },
        data: {
          labels: items.map((d) => d.name),
          datasets: [
            {
              label: "",
              data: items.map((d) => d.count),
              //@ts-ignore
              backgroundColor: items.map((d) => d.color),
              hoverOffset: 4,
            },
          ],
        },
      });
    };

    const are_all_counters_zero = computed(() =>
      data_per_application.value.every((d) => d.count == 0)
    );

    const playbook_desc = computed(() => {
      if (props.source && props.source == "google_workspace") {
        return "";
      } else {
        return `Automate <b>MPIP</b> Sensitivity Labels on Microsoft 365 Information In motion`;
      }
    });

    onMounted(() => {
      watch(
        is_loading_all,
        (val) => {
          if (!val) {
            create_chart(data_per_application.value);
          }
        },
        { deep: true }
      );
    });

    return {
      hover_app_id,
      playbook_desc,
      open_mip_modal,
      is_loading_all,
      data_per_application,
      are_all_counters_zero,
      total_count,
      show_app_events_count_modal,
    };
  },
});
